import React from 'react';
import { KiteIcon } from '@kite/react-kite';
import './QuizStepper.scss';
export interface QuizStepperProps {
    currentStep: number;
    numSteps: number;
    className?: string
}

export const QuizStepper = (props: QuizStepperProps) => {
    return (
        <div className="quiz-stepper" role="presentation">
            <ul className={props.className}>
                {Array.from(Array(props.numSteps)).map((item, idx) => (
                    <li
                        className={
                            idx <= props.currentStep ? `active` : undefined
                        }
                        key={idx}
                    ></li>
                ))}
                {props.currentStep === 4 && (
                    <li className="active" >
                        <KiteIcon 
                            icon="ki-checkmark"
                            size="1.75rem"
                        />
                    </li>
                )}
            </ul>
            <div>
                <span className="accent">{
                    props.currentStep === props.numSteps ? 
                        props.currentStep : props.currentStep + 1
                    }
                </span>
                {` `}/{` `}
                {props.numSteps}
            </div>
        </div>
    );
};